var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractRedliningUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9477 19.3158H17.8758V17.8421H14.9477V19.3158ZM14.9477 16.3684H20.0719V14.8947H14.9477V16.3684ZM12.7516 13.4211H20.0719V11.9474H12.7516V13.4211ZM12.4771 23C11.5133 23 10.6928 22.6592 10.0157 21.9776C9.33856 21.2961 9 20.4702 9 19.5C9 18.8 9.17996 18.1737 9.53987 17.6211C9.89978 17.0684 10.3725 16.6509 10.9582 16.3684H9.0915V14.8947H13.4837V19.3158H12.0196V17.5289C11.5682 17.6272 11.1961 17.8605 10.9033 18.2289C10.6105 18.5974 10.4641 19.0211 10.4641 19.5C10.4641 20.0649 10.6623 20.5439 11.0588 20.9368C11.4553 21.3298 11.9281 21.5263 12.4771 21.5263V23ZM14.9477 22.2632V20.7895H21.5359V10.4737H11.2876V13.4211H9.82353V10.4737C9.82353 10.0684 9.96688 9.72149 10.2536 9.43289C10.5403 9.1443 10.885 9 11.2876 9H21.5359C21.9386 9 22.2832 9.1443 22.5699 9.43289C22.8566 9.72149 23 10.0684 23 10.4737V20.7895C23 21.1947 22.8566 21.5417 22.5699 21.8303C22.2832 22.1189 21.9386 22.2632 21.5359 22.2632H14.9477Z",
    fill: "#6A6A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractRedliningUnselected);
export default __webpack_public_path__ + "static/media/contract_redlining_unselected.8250274e85d82b8b787cf5422439d7a4.svg";
export { ForwardRef as ReactComponent };